import { all } from 'redux-saga/effects';
import Verify from './Verify';
import Provenance from './Provenance';
import Owner from './Owner';
import InspectionReport from './InspectionReport';

export default function* rootSaga(getState) {
  yield all([...Verify, ...Provenance, ...Owner, ...InspectionReport]);
}
